import KidsSVG from "@design-system/ui-icons/vanilla/Kids"
import { createIcon } from "../createIcon"

export const KidsIcon = createIcon(KidsSVG)
